<template>
	<footer>
		<div class="footerContainer">
			<div class="footerItem" :class="{'selected':index==0}" @click="home">
				<span>点餐</span>
				<img src="@/assets/images/index/index_icon_selected.png" v-if="index==0" alt="">
				<img src="@/assets/images/index/index_icon.png" alt="" v-else>
			</div>
			<div class="footerItem" :class="{'selected':index==1}" @click="order">
				<span>订单</span>
				<img src="@/assets/images/index/order_icon_selected.png" v-if="index==1" alt="">
				<img src="@/assets/images/index/order_icon.png" alt="" v-else>
			</div>
			<div class="footerItem" :class="{'selected':index==2}" @click="information">
				<span>我的</span>
				<img src="@/assets/images/index/personal_icon_selected.png" v-if="index==2" alt="">
				<img src="@/assets/images/index/personal_icon.png" alt="" v-else>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	props: {
		index: {
			default: 0
		}
	},
	methods: {
		home() {
			window.location.href = '/'
		},
		order() {
			window.location.href = 'orderList.html'
		},
		information() {
			window.location.href = 'information.html'
		}
	}
}
</script>
<style lang="scss" scoped>
@import "~@/scss/libs.scss";
footer {
	width: 100%;
	height: px2rem(98);
	.footerContainer {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		height: px2rem(98);
		background: white;
		border-top: px2rem(1) solid #e4e4e4;
		display: flex;
		.footerItem {
			flex: 1 0 auto;
			display: flex;
			flex-direction: column-reverse;
			align-items: center;
			img {
				width: px2rem(42);
				display: block;
			}
			span {
				display: block;
				padding: px2rem(10) 0;
				font-size: px2rem(22);
				line-height: 1;
				color: #a6a6a6;
			}
			&.selected{
				img{
					width: px2rem(70);
					flex: 0 0 px2rem(70);
				}
				span{
					color: #73c6c8;
				}
			}
		}
	}
}
</style>
